export default async function fetchIndustries() {
  var industryApiData;
  await fetch(
    "https://recruiter-static-content.s3.ap-south-1.amazonaws.com/CompanyManagement/industries.json"
  )
    .then((response) => response.json())
    .then((data) => (industryApiData = data));
  return industryApiData;
}
